// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3Ln_y","label":"SetPasswdForm_label__xYCqu"};